import { render, staticRenderFns } from "./FormulateCheckboxCards.vue?vue&type=template&id=b50ed10a&"
import script from "./FormulateCheckboxCards.js?vue&type=script&lang=js&"
export * from "./FormulateCheckboxCards.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/develop.mijnmooiestraat.vlaanderen/pro-develop.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b50ed10a')) {
      api.createRecord('b50ed10a', component.options)
    } else {
      api.reload('b50ed10a', component.options)
    }
    module.hot.accept("./FormulateCheckboxCards.vue?vue&type=template&id=b50ed10a&", function () {
      api.rerender('b50ed10a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/Formulate/FormulateCheckboxCards/FormulateCheckboxCards.vue"
export default component.exports